import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AreaApi, CheckDuplicateAreaCodeQuery } from 'api';

export const createImportArea = createAsyncThunk(
  'area/createImportArea',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await AreaApi.createImport(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateAreaCode = createAsyncThunk(
  'area/checkDuplicateAreaCode',
  async (query: CheckDuplicateAreaCodeQuery, { rejectWithValue }) => {
    try {
      const response = await AreaApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateAreaCode = createAsyncThunk(
  'area/generateAreaCode',
  async (query: undefined, { rejectWithValue }) => {
    try {
      const response = await AreaApi.generateCode();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  query: {},
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const areaSlice = createSlice({
  name: 'area',
  initialState,
  reducers: {
    reloadArea(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationArea(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListArea(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: {},
});

const { actions, reducer: areaReducer } = areaSlice;

export const { reloadArea, updateSavedPaginationArea, updateSavedListArea } =
  actions;

export default areaReducer;
